export default __webpack_public_path__ + "static/media/kartu-3.4793fe03.jpg";